import { useEffect } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { ILoginFormValues } from "../../Interfaces/formValue-interfaces";
import { useGeneralHooks } from "../../Hooks/hooks";
import { useLoginMutation } from "../../API/authApi";
import { getMe } from "../../Store/Slices/authSlice";
import { UserRoles } from "../../Interfaces/responseTypes";

const useLoginHooks = () => {
    const { navigate, dispatch, currentUser,accessToken,isUser } = useGeneralHooks();
    const [login, { data: loginResponse, isLoading, isSuccess, isError }] = useLoginMutation();
    const { register, handleSubmit, formState: { errors } } = useForm<ILoginFormValues>();
    const onSubmit: SubmitHandler<ILoginFormValues | FieldValues> = (values) => {
        const payload: ILoginFormValues = {
            username: values.username.trim(),
            password: values.password.trim(),
        };
        login(payload)
    };
    useEffect(() => {
        if (accessToken) {
            navigate('/home');
        }
        else if (loginResponse?.access) {
            localStorage.setItem('p_menu_token', loginResponse?.access);
            dispatch(getMe());
        }
    }, [loginResponse]);

    useEffect(()=>{
        if(isSuccess && isUser(currentUser) ){
            currentUser.user_role === UserRoles.MANAGER
            ?
            navigate('/home')
            :
            navigate('/kkdkdk')
        }
    },[isSuccess,currentUser])



    const onSignUp = () => {
        navigate('/signUp')
    };

    return {
        register,
        onSubmit,
        handleSubmit,
        onSignUp,
        errors,
        isLoading,
        isError
    }
};

export default useLoginHooks